<template>
  <svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="Polygon 6"
      d="M20.0043 17.0843L0.508111 33.6163L0.500582 0.561257L20.0043 17.0843Z"
      fill="#1EEAAD" />
  </svg>
</template>
